import React from 'react';
import {jwtDecode} from 'jwt-decode';
import {ReportTasksPanel} from './ReportTasksPanel';
import {collaborationApi as api} from './collaborationApi';
export default function PropertyWorkPanel({propertyId, cosJobId, onIssueSummaryChanged}) {
    const token = localStorage.getItem('cosToken');
    let role = '';
    try { role = jwtDecode(token).optinestUser?.optinestApiUser?.role || ''; } catch (_) { /* Login owns missing-token recovery. */ }
    return <ReportTasksPanel key={`${token}:${propertyId}`} propertyId={propertyId} cosJobId={cosJobId} api={api} role={role}
        onIssueSummaryChanged={onIssueSummaryChanged}/>;
}
